"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { NotificationDisplayItem } from "@/types/feed.types";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import NotificationItems from "./NotificationItems";
import { useRouter } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
type WaveWithChatScope = ExtendedDrop["wave"] & {
  is_direct_message?: boolean | undefined;
  chat?: {
    scope?: {
      group?: {
        is_direct_message?: boolean | undefined;
      } | undefined;
    } | undefined;
  } | undefined;
};
const hasChatScope = (wave: ExtendedDrop["wave"]): wave is WaveWithChatScope => "chat" in wave || "is_direct_message" in wave;
interface NotificationsWrapperProps {
  readonly items: NotificationDisplayItem[];
  readonly loadingOlder: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly setActiveDrop: (drop: ActiveDropState | null) => void;
  readonly markNotificationIdsAsRead?: (ids: number[]) => Promise<void>;
}
export default function NotificationsWrapper(t0) {
  const $ = _c(16);
  const {
    items,
    loadingOlder,
    activeDrop,
    setActiveDrop,
    markNotificationIdsAsRead
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] !== isApp || $[1] !== router) {
    t1 = drop => {
      if (!drop?.wave?.id) {
        return;
      }
      const isDirectMessage = hasChatScope(drop.wave) ? drop.wave.chat?.scope?.group?.is_direct_message ?? drop.wave.is_direct_message ?? false : false;
      const href = getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage,
        isApp
      });
      router.push(href);
    };
    $[0] = isApp;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onDropContentClick = t1;
  let t2;
  if ($[3] !== setActiveDrop) {
    t2 = param => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop: param.drop,
        partId: param.partId
      });
    };
    $[3] = setActiveDrop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onReply = t2;
  let t3;
  if ($[5] !== loadingOlder) {
    t3 = loadingOlder && <div className="tw-flex tw-w-full tw-justify-center tw-py-3"><div className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-uppercase tw-tracking-wide tw-text-iron-400"><span className="tw-inline-flex tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-iron-400 tw-border-t-transparent" /><span>Loading older notifications...</span></div></div>;
    $[5] = loadingOlder;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeDrop || $[8] !== items || $[9] !== markNotificationIdsAsRead || $[10] !== onDropContentClick || $[11] !== onReply) {
    t4 = <NotificationItems items={items} activeDrop={activeDrop} onReply={onReply} onDropContentClick={onDropContentClick} onMarkGroupAsRead={markNotificationIdsAsRead} />;
    $[7] = activeDrop;
    $[8] = items;
    $[9] = markNotificationIdsAsRead;
    $[10] = onDropContentClick;
    $[11] = onReply;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="tw-relative tw-flex tw-flex-col tw-gap-3">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}